class Clouds {
	constructor() {
		this.parallaxClouds();
	}

	parallaxClouds() {
		const clouds = document.querySelectorAll(".cloud");

		clouds.forEach(cloud => {
			let distance = 0;

			if (cloud.classList.contains("cloud-left")) {
				distance = "120%";
			}

			if (cloud.classList.contains("cloud-right")) {
				distance = "-120%";
			}

			gsap.to(cloud, {
				scrollTrigger: {
					trigger: cloud,
					scrub: 3,
					start: "top bottom",
					end: "bottom top",
				},
				y: distance,
				duration: 1
			});
		});
	}
}